
import i18n from "../../i18n";

export const VALUELISTID_CLASS = 1;
export const VALUELISTID_WORKFLOW = 7;
export const VALUELISTID_STATE = 8;

export const translateMFilesString = (key: string, fallbackTranslation: string | null): string => {
  const namespacekey = `mfiles:${key}`;
  const translated = i18n.t(namespacekey);
  if(translated === key || translated === namespacekey) {
    return fallbackTranslation;
  }
  return translated;
}

export const translateObjectTypeName = (objectTypeId: number, fallbackTranslation: string | null): string => {
  return translateMFilesString(`ObjectType_${objectTypeId}_0_Name`, fallbackTranslation);
}

export const translateObjectTypeNamePlural = (objectTypeId: number, fallbackTranslation: string | null): string => {
  return translateMFilesString(`ObjectType_${objectTypeId}_0_NamePlural`, fallbackTranslation);
}

export const translatePropertyDefName = (propertyId: number, fallbackTranslation: string | null): string => {
  return translateMFilesString(`PropertyDef_${propertyId}_0_Name`, fallbackTranslation);
}

export const translateValueListItemName = (valueListId: number, valueListItemId: number, fallbackTranslation: string | null): string => {
  return translateMFilesString(`Item_${valueListId}_${valueListItemId}_Name`, fallbackTranslation);
}

export const translateObjectClassName = (classId: number, fallbackTranslation: string | null): string => {
  return translateValueListItemName(VALUELISTID_CLASS, classId, fallbackTranslation);
}

export const translateWorkflowName = (workflowId: number, fallbackTranslation: string | null): string => {
  return translateValueListItemName(VALUELISTID_WORKFLOW, workflowId, fallbackTranslation);
}

export const translateStateName = (stateId: number, fallbackTranslation: string | null): string => {
  return translateValueListItemName(VALUELISTID_STATE, stateId, fallbackTranslation);
}
